import crypto from 'crypto';

export default function geradorIdUnico() {
  return crypto.randomBytes(16).toString('hex');
}

export function getValueTagGA(key) {
  const tagsGa = new Map();
  tagsGa.set('tipoDirecionamento', 'Tipo de Direcionamento');
  tagsGa.set('direcionamento', 'Direcionamento');
  tagsGa.set('dataInicio', 'Data Inicial');
  tagsGa.set('dataFim', 'Data Final');
  tagsGa.set('status', 'Status do Lote');
  tagsGa.set('volume', 'Volume Total (ton)');
  tagsGa.set('cadencia', 'Cadência Diária (ton)');
  tagsGa.set('freteMotoristaPj', 'Frete Motorista (PJ)');
  tagsGa.set('freteEmpresaPj', 'Frete Empresa (PJ)');
  tagsGa.set('freteMotoristaPf', 'Frete Motorista (PF)');
  tagsGa.set('freteEmpresaPf', 'Frete Empresa (PF)');
  tagsGa.set('direcionadoPara1', 'Direcionado');
  tagsGa.set('direcionadoPara2', 'Direcionado');
  tagsGa.set('direcionadoPara3', 'Direcionado');
  return tagsGa.get(key);
}

export const geraKey = id => id + crypto.randomBytes(4).toString('hex');
